module.exports = __webpack_public_path__ + "img/icon-up.1c5a64a2.svg";